import React from "react";
import './rotatescreen.css'

export default function RotateScreen({ show }) {
  const visibilityClassName = show ? 'visible' : 'invisible';
  return (
    <div className={`container-flex rotatescreen ${visibilityClassName}`}>
      <div className="row h-100 justify-content-center align-items-center rotatescreen-container">
        <div className="col-12 text-center">
          <h1>PLEASE <br/> ROTATE TO <br/> LANDSCAPE</h1>
        </div>
      </div>
    </div>
  );
}


